import { Controller } from "@hotwired/stimulus";
import CyrillicToTranslit from "cyrillic-to-translit-js";

export default class extends Controller {
  static targets = ['select', 'inputSearch', 'inputResults', 'list', 'dropdown'];

  connect() {
    this.selections = [];
    this.options = [...this.selectTarget.options].map((o) => {
      let name = o.dataset.searchfield || o.text;
      if (o.selected) this.selections.push({ id: o.value, name: name, displayName: o.text })
      return { id: o.value, name: name, displayName: o.text }
    });
    this.multiple = this.selectTarget.multiple;
    this.drawControls();
    this.filteredOptions = this.options;
    this.addEvents();
    this.apply();
    this.render();
    if (this.selectTarget.dataset.cleared == 'true') {
      this.clear();
    }
  }

  drawControls() {
    this.selectTarget.style.display = 'none';
    let placeholder = this.selectTarget.dataset.prompt;
    if (placeholder === undefined) {
      placeholder = '';
    };

    if (this.element.children.length > 0) {
      this.element.lastChild.remove();
    };

    this.element.insertAdjacentHTML('beforeend',
      `
    <div class="select-search-box relative">
      <div class="flex gap-x-1.5  w-full">
        <input class="${this.selectTarget.classList} w-full" placeholder="${placeholder}" data-${this.identifier}-target="inputResults" readonly />
        <svg class="pointer-events-none absolute right-0 mt-3 mr-1 size-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
          <path fill-rule="evenodd" d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
        </svg>
      </div>
          
       <div data-${this.identifier}-target="dropdown" class="hidden w-full absolute z-40 max-h-80 rounded-xs bg-white py-1 mt-1 px-1 text-base ring-1 shadow-lg focus:outline-hidden">
        <div class="select-search-input flex">
          <input type="text" data-${this.identifier}-target="inputSearch" placeholder="Поиск..." class="font-normal border-gray-400 text-gray-400 rounded-xs text-sm border p-2 bg-white placeholder-gray-400 text-gray-500 appearance-none w-full block focus:ring-0">
          <button id="search-selected" title="Показать выбранные" type="button" style="margin-left: 6px;" class="rounded-xs bg-white px-3 py-2 text-sm font-semibold text-gray-600 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto" data-action="${this.identifier}#filterSelected">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon" class="size-5">
              <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5"></path>
            </svg>
          </button>
          <button id="search-clear" title="Сбросить фильтры" type="button" style="margin-left: 6px;" class="hidden rounded-xs bg-white px-3 py-2 text-sm font-semibold text-gray-600 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto" data-action="${this.identifier}#filterEmpty">
           <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon" class="size-5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
        <ul class="select-search-list mt-2 overflow-y-auto max-h-56 ring-gray-300 sm:text-sm" tabindex="-1" role="listbox" aria-labelledby="listbox-label" aria-activedescendant="listbox-option-3">
          <div class="select-search-results" data-${this.identifier}-target="list">
          </div>
        </ul>
      </div>
    </div>`
    );

    if (this.multiple) {
      this.dropdownTarget.insertAdjacentHTML('beforeend',
        `
      <div class="mt-2 select-search-buttons flex justify-between">
        <button type="button" class="rounded-xs px-3 py-2 text-sm font-semibold text-gray-600 hover:bg-gray-50 sm:mt-0 sm:w-auto" data-action="${this.identifier}#close">Закрыть</button>
        <button type="button" class="rounded-xs px-3 py-2 text-sm font-semibold text-gray-600 hover:bg-gray-50 sm:mt-0 sm:w-auto text-red-700" data-action="${this.identifier}#clear">Очистить</button>
      </div>
      `
      );
    }

  }

  addEvents() {
    let dropdown = this.dropdownTarget;
    this.inputSearchTarget.addEventListener('input', (e) => {
      this.filter(e.target.value);
      document.getElementById("search-clear").classList.remove("hidden");
    });
    this.inputResultsTarget.addEventListener('click', () => {
      dropdown.style.display = 'block';
    });
    document.addEventListener("click", (event) => {
      if (event.target.closest('.dropdown-item, .select-search-box')) return;
      dropdown.style.display = 'none';
    });
    window.onblur = () => {
      dropdown.style.display = 'none';
    };
  }

  filterEmpty() {
    this.inputSearchTarget.value = '';
    this.filter('');
  }

  filterSelected() {
    this.filteredOptions = this.options.filter((o) => {
      return this.selections.some(s => s.id === o.id)
    });
    document.getElementById("search-clear").classList.remove("hidden");
    this.render();
  }

  filter(pattern) {
    const cyrillicToTranslit = new CyrillicToTranslit();
    pattern = pattern.replace(/(?=[() ])/g, '\\');
    this.query = new RegExp(`(${pattern})`, "ig");
    this.filteredOptions = this.options.filter((o) => {
      let en_name = cyrillicToTranslit.transform(o.name);
      return (o.name.match(this.query) || en_name.match(this.query))
    });
    this.render();
  }

  select(event) {
    let id = event.target.dataset.optionId;
    this.optionsSelect(id)
    if (!this.multiple) this.dropdownTarget.style.display = 'none';
  }

  apply() {
    this.selectTarget.value = "";
    this.selections.forEach((selection) => {
      this.selectTarget.querySelector('[value="' + selection.id + '"]').selected = true;
    });
    this.selectTarget.dispatchEvent(new Event('change'));
  }

  highlight(text, id) {
    let result = text;
    if (this.query) {
      result = text.replace(this.query, "<span data-option-id='" + id + "' class='select-search-highlight'>$1</span>");
    }
    return result;
  }

  optionsSelect(selectedId) {
    let uniq_selections = [];
    let ids = new Set(this.selections.map(element => element.id));
    if (ids.has(selectedId)) {
      ids.delete(selectedId);
    } else {
      ids.add(selectedId);
    };
    ids.forEach((id) => {
      let option = this.options.find(x => x.id === id)
      uniq_selections.push({ id: id, name: option.name, displayName: option.displayName });
    });
    if (!this.multiple) uniq_selections = uniq_selections.slice(-1);
    this.selections = uniq_selections;
    this.render();
  }

  clear() {
    this.inputSearchTarget.value = '';
    this.selections = [];
    this.filter('');
  }

  close() {
    this.dropdownTarget.style.display = 'none';
  }

  render() {
    this.listTarget.innerHTML = '';
    this.filteredOptions.forEach(o => {
      let selected = this.selections.map(element => element.id).includes(o.id) ? 'bg-orange-100' : '';
      this.listTarget.insertAdjacentHTML('beforeend', `
        <li class="${selected} ${o.id ? '' : 'hidden'} hover:bg-gray-50 relative cursor-pointer py-2 pr-9 pl-3 text-gray-900">
           <a class="block font-medium no-underline dropdown-item" data-option-id="${o.id}"
           data-action="${this.identifier}#select">${this.highlight(o.displayName, o.id)}</a>
        </li>`)
    });
    if (this.filteredOptions.length == 0) {
      this.listTarget.insertAdjacentHTML('beforeend', `<a class="dropdown-item  py-2 pr-9 pl-3 text-gray-900 font-medium no-underline">Нет совпадений</a>`)
    };
    this.inputResultsTarget.value = this.selections.map(element => element.displayName).join(', ');
    this.apply();
  }
}
